import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import MembersSidebar from '../components/MembersSidebar';

const MembersHome = () => {
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Get member data from localStorage
    const memberData = localStorage.getItem('member_data');
    if (memberData) {
      const parsedMember = JSON.parse(memberData);
      setMember(parsedMember);
    }
  }, []);

  const handleLogout = async () => {
    setLoading(true);
    
    try {
      const token = localStorage.getItem('member_token');
      if (token) {
        await axios.post('https://backend.dlapakistan.com/api/members/logout/', {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
      }
    } catch (error) {
      console.log('Logout API error:', error);
    }
    
    localStorage.removeItem('member_token');
    localStorage.removeItem('member_data');
    
    if (axios.defaults.headers.common['Authorization']) {
      delete axios.defaults.headers.common['Authorization'];
    }
    
    Swal.fire({
      icon: 'success',
      title: 'Signed Out',
      text: 'You have been signed out successfully.',
      timer: 2000,
      showConfirmButton: false,
    });
    
    navigate('/members/members-area');
    setLoading(false);
  };

  if (!member) {
    return (
      <Container fluid className="py-5 min-vh-100 mt-40" style={{ maxWidth: '95%' }}>
        <div className="text-center py-5">
          <p>Loading...</p>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="py-5 min-vh-100 mt-40" style={{ maxWidth: '95%' }}>
      {/* Header with user info and logout */}
      <div className="mb-6">
        <h1 className="display-6 text-dark mb-3">
          Hello {member.first_name} {member.last_name}
        </h1>
        <p className="text-muted mb-3">
             Manage Account Details!{' '}{' '}{' '}
          <Button 
            variant="link" 
            onClick={handleLogout}
            disabled={loading}
            className="text-danger p-0"
            style={{ textDecoration: 'none' }}
          >
            {loading ? 'Signing out...' : 'Log out'}
          </Button>
        </p>
      </div>

      <Row className="g-4">
        {/* Sidebar Column */}
        <Col lg={3} md={4}>
          <MembersSidebar />
        </Col>

        {/* Content Column */}
        <Col lg={9} md={8}>
          <div className="bg-white shadow-sm rounded-lg p-4 p-lg-5">
            {/* Content aligned to the left */}
            <div className="text-left">
              <h4 className="text-[#70B444] mb-4">Account Dashboard</h4>
              
              {/* The paragraph aligned left */}
              <div className="mb-4">
                <p className="text-gray-700 mb-0">
                  From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details.
                </p>
              </div>
              
              {/* Optional message about sidebar - aligned left */}
              <p className="text-muted mb-4">
                Select an option from the sidebar to manage your account.
              </p>
              
         
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MembersHome;